// app/providers.tsx
"use client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState } from "react";

export default function Providers({ children }: { children: React.ReactNode }) {
    const [queryClient] = useState(
        () =>
            new QueryClient({
                defaultOptions: {
                    queries: {
                        // Data stays fresh for 5 min — prevents refetch on every navigation
                        staleTime: 1000 * 60 * 5,
                        // No background refetch when the tab regains focus
                        refetchOnWindowFocus: false,
                        // Only retry once on failure instead of the default 3
                        retry: 1,
                    },
                },
            })
    );

    return (
        <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    );
}
